<script setup lang="ts">
import { computed, ref, watch } from 'vue'

const props = withDefaults(defineProps<{
  src?: string
  alt?: string
  letter?: string
  size?: number
}>(), {
  src: '',
  alt: '用户头像',
  letter: '?',
  size: 24,
})

const loadFailed = ref(false)

watch(
  () => props.src,
  () => {
    loadFailed.value = false
  },
)

const avatarStyle = computed(() => ({
  width: `${Math.max(16, Number(props.size) || 24)}px`,
  height: `${Math.max(16, Number(props.size) || 24)}px`,
}))

function handleError() {
  loadFailed.value = true
}
</script>

<template>
  <span class="auth-avatar" :style="avatarStyle">
    <img
      v-if="src && !loadFailed"
      class="auth-avatar__img"
      :src="src"
      :alt="alt"
      draggable="false"
      referrerpolicy="no-referrer"
      @error="handleError"
    />
    <span v-else class="auth-avatar__fallback">{{ (letter || '?').charAt(0) }}</span>
  </span>
</template>

<style scoped>
.auth-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex: 0 0 auto;
  border: 1px solid var(--theme-border);
  border-radius: 50%;
  background: var(--theme-bg-card);
  color: var(--theme-text-heading);
  box-sizing: border-box;
  user-select: none;
}

.auth-avatar__img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.auth-avatar__fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 1;
}
</style>
